module.exports = __webpack_public_path__ + "static/img/logo.ebf3f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/tqjg/logo.png
// module id = HpXb
// module chunks = 23